import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.mobileGallery = new Swiper('.mobile-gallery-container', {
      loop: false,
      height: 153
    });
  }

  galleryPrev() {
    this.mobileGallery.slidePrev();
  }

  galleryNext() {
    let slideCallback = this.mobileGallery.slideNext();

    if(slideCallback == false){
      this.mobileGallery.slideTo(0);
    }
  }

}